import LoginView from '@/views/account/LoginView.vue';
import SupportView from '@/views/about/SupportView.vue';
import TeamsDisplayView from '@/views/teamsDisplay/TeamsDisplayView.vue';
import CriteriaSelectionView from '@/views/criteriaSelection/CriteriaSelectionView.vue';

export const standardRoutes = [
  {
    path: '/display',
    name: 'TeamsDisplayView',
    component: TeamsDisplayView,
    meta: { guest: true },
  },
  {
    path: '/criteria-countdown',
    name: 'CriteriaSelectionView',
    component: CriteriaSelectionView,
    meta: { guest: true },
  },
  {
    path: '/about/support',
    name: 'Support',
    component: SupportView,
    meta: { guest: true },
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: { guest: true },
  },
];
